import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'

const menuClass = 'navbar-item title is-6 is-mega-menu-title'
const NoSubMenu = ({ item }) => {
  return (
    <div className="column is-4">
      {item.map(menu => (
        <Link key={menu.title} to={menu.url} className={menuClass}>
          {menu.title}
        </Link>
      ))}
    </div>
  )
}
const WithSubMenu = ({ item }) => {
  return item.map(menu => (
    <div key={menu.title} className="column is-4">
      <Link to={menu.url} className={menuClass}>
        {menu.title}
      </Link>
      {menu.categories.map(c => (
        <Link
          key={c.categoryName}
          to={menu.url.slice(0, -1) + '#' + c.categoryName}
          className="navbar-item"
        >
          {c.categoryName}
        </Link>
      ))}
    </div>
  ))
}

const MegaMenu = ({ item, toggle }) => {
  const withSubmenuItems = item.submenu.filter(menu => menu.haveCategory)
  const noSubmenuItems = item.submenu.filter(menu => !menu.haveCategory)

  return (
    <div
      id="top"
      onClick={toggle}
      className="navbar-item has-dropdown is-mega is-hoverable"
    >
      <Link key={item.name} to={item.url} className="navbar-link">
        {item.name}
      </Link>
      <div className="navbar-dropdown">
        <div className="container is-fluid">
          <div className="column is-10 is-offset-1">
            <div className="columns is-multiline">
              <NoSubMenu item={noSubmenuItems} />
              <WithSubMenu item={withSubmenuItems} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

class Navbar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active: false,
    }
    this.toggleNav = this.toggleNav.bind(this)
    this.activeClass = this.activeClass.bind(this)
  }

  toggleNav() {
    this.setState((state, props) => ({
      active: !state.active,
    }))
  }

  activeClass() {
    return this.state.active ? ' is-active' : ''
  }

  render() {
    const { logo, items } = this.props
    const { active } = this.state

    return (
      <nav className="navbar is-transparent">
        <div className="centerized">
          <div className="navbar-brand">
            <Link to="/" className="logo-item navbar-item">
              <figure className="image">
                <img src={logo} alt="Caffe Bene" style={{ width: '120px' }} />
              </figure>
            </Link>
            <div
              className={'navbar-burger' + this.activeClass()}
              onClick={this.toggleNav}
              aria-label="menu"
              aria-expanded="false"
            >
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </div>
          </div>

          <div className={'navbar-menu' + this.activeClass()}>
            <div className="navbar-start">
              {items.map(item => {
                if (item.hoverable && item.megaMenu) {
                  return (
                    <MegaMenu
                      key={item.name}
                      toggle={this.toggleNav}
                      item={item}
                    />
                  )
                } else if (item.hoverable) {
                  return (
                    <div
                      key={item.name}
                      onClick={this.toggleNav}
                      className="navbar-item has-dropdown is-hoverable"
                    >
                      <Link to={item.url} className="navbar-link">
                        {item.name}
                      </Link>
                      <div className="navbar-dropdown">
                        {item.submenu.map(i => (
                          <Link
                            key={i.title}
                            to={i.url}
                            className="navbar-item"
                          >
                            {i.title}
                          </Link>
                        ))}
                      </div>
                    </div>
                  )
                } else {
                  return (
                    <div
                      key={item.name}
                      className="navbar-item"
                      onClick={this.toggleNav}
                    >
                      <Link className="navbar-item" to={item.url}>
                        {item.name}
                      </Link>
                    </div>
                  )
                }
              })}
            </div>
          </div>
        </div>
      </nav>
    )
  }
}

Navbar.propTypes = {
  logo: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string,
    })
  ),
}

export default Navbar
